<template>
  <b-row class="my-4 o-info">
    <b-col
      md="12"
      lg="auto"
      class="o-info o-strong text-truncate"
    >
      <span class="o-label-sm">NAME:</span>
      <span>&nbsp; {{ tenant.name }}</span>
    </b-col>
    <b-col
      md="12"
      lg="auto"
      class="o-info o-strong text-truncate"
    >
      <span class="o-label-sm">ID:</span>
      <span>&nbsp; {{ tenant.tenantId }}</span>
    </b-col>
    <b-col
      md="12"
      lg="auto"
      class="o-info o-strong text-truncate"
    >
      <span class="o-label-sm">SUBDOMAIN:</span>
      <span>&nbsp; {{ tenant.subdomain }}</span>
    </b-col>
    <b-col
      md="12"
      lg="auto"
    />
  </b-row>
</template>

<script>
export default {
  data() {
    return {
      tenant: {}
    };
  },
  mounted() {
    this.$axios
      .get(`/api/tenants/${this.$route.params.tenantId}`)
      .then(response => {
        this.tenant = response.data;
      })
      .catch();
  }
};
</script>
